import React, { useState } from 'react'
import { Row, Col, Tabs, Card } from 'antd'

import { connect } from 'react-redux'

import CardStatement from './CardStatement'

import './index.scss'

const TransferBanks: React.FC<any> = () => {
  const { TabPane } = Tabs
  return (
    <Row>
      <Col span={24}>
          <CardStatement />
      </Col>
    </Row>
  )
}

export default connect(null, null)(TransferBanks)
